import CreateIdentityModal from "./CreateIdentityModal"

export default CreateIdentityModal
